import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { ReactiveFormsModule } from '@angular/forms';
import { TuiButtonLoading } from '@taiga-ui/kit';
import { TuiButton } from '@taiga-ui/core';
import { TuiTextfieldControllerModule, TuiInputDateModule } from '@taiga-ui/legacy';
import { TranslateModule } from '@ngx-translate/core';

import { ReportsComponent } from './reports.component';
import { ReportsService } from './services';
import { ReportFormComponent } from './report-form/report-form.component';
import { ReportsButtonComponent } from './reports-button/reports-button.component';

@NgModule({
  declarations: [ReportsComponent, ReportFormComponent, ReportsButtonComponent],
  imports: [
    CommonModule,
    ReactiveFormsModule,
    TranslateModule,
    TuiButton,
    TuiInputDateModule,
    TuiTextfieldControllerModule,
    TuiButtonLoading,
  ],
  providers: [ReportsService],
  exports: [ReportsComponent, ReportsButtonComponent],
})
export class ReportsModule {}
